import styled from 'styled-components' 

export const QualifierLayout = styled.div`
    display: flex;
    gap: 24px;
    width: 100%;
    padding: 24px 32px 40px;
    align-items: flex-start;

    @media (max-width: 1100px) {
        flex-direction: column;
    }
`;

export const QualifierColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    width: 0;
    min-width: 0;
`;

export const SectionTitle = styled.h3`
    margin: 0;
    font-size: 18px;
    font-weight: 600;
`;

export const ContainerImages = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 12px;
    width: 100%;
`;

export const ImageCard = styled.div`          
    display: flex;
    flex-direction: column;
    width: 100%; 
    border: 1px solid #ececec;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
`;
 
export const ImageCardImage = styled.div`          
    width: 100%;
    aspect-ratio: 2 / 2;
    background: #efefef url(${ p => p.image }) no-repeat center center / cover;
`;
 
export const ImageCardContent = styled.div`          
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 12px 12px;
    flex:1;
    overflow: hidden;
`;

export const ImageCardContentText = styled.div`          
    font-size: 14px;
    font-weight: 400;
`;

export const AiSuggestionText = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #1f63ff;
`;

export const StatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    width: fit-content;
    padding: 4px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    background: ${({ status }) => status === 'success' ? '#eaf8ef' : '#fff1f1'};
    color: ${({ status }) => status === 'success' ? '#207a3f' : '#b00020'};
`;
 
